import RestDay from '../../model/RestDay'
import CountdownTimer from '../primitives/CountdownTimer'
import styles from './RestDayLockdown.module.css'

export interface RestDayLockdownScreenProps {
  restDay: RestDay
  onExpired?: () => void
}

export default function RestDayLockdownScreen({
  restDay,
  onExpired,
}: RestDayLockdownScreenProps) {
  return (
    <div className={styles.lockdown}>
      <div>
        <h1 className={styles.title}>Rest day active</h1>
        <p className={styles.subtitle}>
          You&apos;ll be able to log activities again when your rest day ends.
        </p>
      </div>
      <CountdownTimer targetDate={restDay.endTime} onComplete={onExpired} />
    </div>
  )
}
